import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Button} from 'primeng/button';
import {FormsModule} from '@angular/forms';
import {InputText} from 'primeng/inputtext';
import {Popover} from 'primeng/popover';
import {TimePickerComponent} from '../../components/time-picker';
import dayjs from 'dayjs';

@Component({
  selector: 'ng-due-time-item',
  imports: [
    Button,
    FormsModule,
    InputText,
    Popover,
    TimePickerComponent
  ],
  template: `
    <input pInputText [(ngModel)]="time" (click)="popover.toggle($event)" style="width: 86px"/>
    <p-button icon="fa fa-times" [rounded]="true" [text]="true" severity="danger" (click)="onDelete.emit()"/>
    <p-popover #popover>
      <ng-time-picker
        [(ngModel)]="time"
        format="hh:mm A"
        [minute-step]="15"
        [showPeriod]="true"
        (timeChange)="Sync()"
      />
    </p-popover>
  `
})
export class DueTimeItem implements OnInit {
  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();
  @Output() onDelete = new EventEmitter<void>();

  public time = "00:00 AM"

  ngOnInit() {
    if(this.value) {
      this.time = dayjs(this.value, "HH:mm:ss").format("hh:mm A");
    }
  }

  Sync() {
    this.value = dayjs(this.time, "hh:mm A").format("HH:mm:ss");
    this.valueChange.emit(this.value);
  }
}
